import { Paper, Title, Stack, Loader, Center } from "@mantine/core";
import { useCustomerInsuranceStore } from "../../hooks/ui/customerInsuranceStore";

import OldElementComponent from "../insuranceElements/old-element";
import EftElementComponent from "../insuranceElements/eft-element";
import { v4 as uuidV4 } from "uuid";

const InsuranceElement = () => {
  const data = useCustomerInsuranceStore.getState()?.insurance;
  const isLoading = useCustomerInsuranceStore.getState()?.isLoading;
  const elements = data?.elements;

  if (isLoading) {
    return (
      <Paper p={{ base: "lg", sm: "xl" }} radius={"lg"} mb={"xl"}>
        <Center py="lg">
          <Loader />
        </Center>
      </Paper>
    );
  }

  return elements ? (
    <Paper p={{ base: "lg", sm: "xl" }} radius={"lg"} mb={"xl"}>
      <Title order={4} mb={"lg"} ff={"var(--wallet-font-family-sambla-sans)"}>
        Försäkringsmoment
      </Title>
      <Stack gap="md">
        {elements.map((element) => (
          <div key={uuidV4()}>
            {element.type === "OLD" ? (
              <OldElementComponent element={element} insurance={data} />
            ) : (
              <EftElementComponent element={element} />
            )}
          </div>
        ))}
      </Stack>
    </Paper>
  ) : null;
};

export default InsuranceElement;
